import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Auto-reveal any element with class "reveal-on-scroll" as it enters the viewport.
 * Mounts once, re-scans on every route change so newly mounted sections animate too.
 */
export default function useRevealOnScroll() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || !("IntersectionObserver" in window)) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      // Show everything immediately if the user prefers reduced motion
      document.querySelectorAll(".reveal-on-scroll").forEach((el) => el.classList.add("is-visible"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );

    // Small timeout lets new routes render before we observe
    const t = setTimeout(() => {
      document.querySelectorAll(".reveal-on-scroll:not(.is-visible)").forEach((el) => {
        observer.observe(el);
      });
    }, 60);

    return () => {
      clearTimeout(t);
      observer.disconnect();
    };
  }, [location.pathname]);
}
